<div class="flex-fill ui-create-page edge-edit" *ngrxLet="selectActiveLevel2$; let activeLevel2">
  <div class="h-100 w-100">
    <ui-header-with-breadcrumbs>
      <div class="flex-row end-center gap-10">
        <ui-progress-button *ngIf="
              activeLevel2 === menuKeys.details || activeLevel2 === menuKeys.configuration"
                            [loading]="selectIsSaving$ | ngrxPush"
                            [text1]="'COMMON.SAVE'|translate"
                            [text2]="'COMMON.SAVED'|translate"
                            [disabled]="!(selectIsLocationDetailsFormValid$ | async)"
                            (clickAction)="save()"
        >
        </ui-progress-button>
        <ui-progress-button
          *ngIf="
              activeLevel2 === menuKeys.speakers
        "
          [loading]="selectIsSaving$ | ngrxPush"
          [text1]="'LOCATION_EDIT.ADD_SPEAKER'|translate"
          [text2]="'LOCATION_EDIT.ADD_SPEAKER'|translate"
          class="add-speaker-button"
          (clickAction)="addSpeaker()"
        >
        </ui-progress-button>
        <ng-container *ngrxLet="selectDeviceState$; let deviceState">
          <ui-progress-button
            *ngIf="
              activeLevel2 === menuKeys.addSpeaker
        "
            [disabled]="!deviceState?.testSuccess"
            [loading]="selectIsSaving$ | ngrxPush"
            [text1]="'COMMON.SAVE'|translate"
            [text2]="'COMMON.SAVED'|translate"
            (clickAction)="create()"
          >
          </ui-progress-button>
          <ui-button
            type="primary"
            *ngIf="
              activeLevel2 === menuKeys.addSensor
        "
            [disabled]="!deviceState?.testSuccess"
            [loading]="selectIsSaving$ | ngrxPush"
            (clickAction)="create()"
          >{{ isCreate ? ('LOCATION_EDIT.CREATE_SENSOR'|translate) : ('COMMON.SAVE'|translate) }}
          </ui-button>
        </ng-container>

        <ui-progress-button
          *ngIf="
              activeLevel2 === menuKeys.appleTvListEdit
        "
          [loading]="selectIsSavingAppleTV$ | ngrxPush"
          [disabled]="!(selectIsFormValid$|ngrxPush)"
          [text1]="'LOCATION_EDIT.SAVE_STREAM'|translate"
          [text2]="'LOCATION_EDIT.SAVE_STREAM'|translate"
          (clickAction)="create()"
        >
        </ui-progress-button>
        <ui-progress-button
          *ngIf="
              activeLevel2 === menuKeys.appleTvListCreate
        "
          [loading]="selectIsSavingAppleTV$ | ngrxPush"
          [disabled]="!(selectIsFormValid$|ngrxPush)"
          [text1]="'LOCATION_EDIT.CREATE_STREAM'|translate"
          [text2]="'LOCATION_EDIT.CREATE_STREAM'|translate"
          (clickAction)="create()"
        >
        </ui-progress-button>

        <ui-progress-button
          *ngIf="
              activeLevel2 === menuKeys.externalStorageEdit
        "
          [loading]="selectIsSavingExternalStorage | ngrxPush"
          [disabled]="!(selectIsExternalStorageFormValid$|ngrxPush)"
          [text1]="'LOCATION_EDIT.SAVE_EXTERNAL_STORAGE'|translate"
          [text2]="'COMMON.DONE'|translate"
          (clickAction)="create()"
        >
        </ui-progress-button>
        <ui-progress-button
          *ngIf="
              activeLevel2 === menuKeys.remoteIosEdit
        "
          [loading]="selectIsSavingRemoteIO | ngrxPush"
          [disabled]="!(selectIsRemoteIOFormValid$|ngrxPush)"
          [text1]="'LOCATION_EDIT.SAVE_REMOTE_IO'|translate"
          [text2]="'COMMON.DONE'|translate"
          (clickAction)="create()"
        >
        </ui-progress-button>
      </div>
    </ui-header-with-breadcrumbs>
    <div class="ui-router-wrapper flex-row">
      <ui-menu-level2 *ngIf="activeLevel2 !== menuKeys.sensorView"
                      [showValidPoints]="false" [validPoints]="selectLevel2MenuValid$ | ngrxPush"
      ></ui-menu-level2>
      <div class="router-content w-100">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
